export default function appendHeightParam(url: string, height: number): string {
  try {
    const parsedUrl = new URL(url, window.location.origin);
    parsedUrl.searchParams.set("height", height.toString());
    return parsedUrl.toString();
  } catch (error) {
    console.error("Invalid URL:", error);
    return url; // Return the original URL if parsing fails
  }
}